import { Flex } from "antd";
import { countries } from "../constants/enums.ts";

type CountryFlagProps = {
  countryCode: string;
  flagOnly?: boolean;
};

export const CountryFlag = ({ countryCode, flagOnly = false }: CountryFlagProps) => {
  const flagIcon = <span className={`fi fi-${countryCode.toLowerCase()}`} />;

  if (flagOnly) {
    return flagIcon;
  }

  const countryName = countries[countryCode as keyof typeof countries] ?? countryCode;
  return (
    <Flex align="center" gap={8}>
      {flagIcon}
      {countryName}
    </Flex>
  );
};
